import { render, staticRenderFns } from "./favorite-express.vue?vue&type=template&id=80d5e284&scoped=true&"
import script from "./favorite-express.vue?vue&type=script&lang=js&"
export * from "./favorite-express.vue?vue&type=script&lang=js&"
import style0 from "./favorite-express.vue?vue&type=style&index=0&id=80d5e284&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d5e284",
  null
  
)

export default component.exports